import { createAction } from '@reduxjs/toolkit';

export const ADD_EMPTY_SHOPS = 'orders/getEmptyShops';

export const addEmptyArrayShopList = createAction(
    ADD_EMPTY_SHOPS,
    () => ({ payload: { shopList: undefined } }),
);
